import Api from "@/services/api";
import { CopyStyle, ChannelStyle } from "@/services/styles/types";

export async function getAllChannelStyles(): Promise<Array<ChannelStyle>> {
    return new Promise((resolve, reject) => {
        Api.get("/channelStyles").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getChannelStyle(id: string): Promise<ChannelStyle> {
    return new Promise((resolve, reject) => {
        Api.get(`/channelStyles/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getChannelStylesByType(type: string): Promise<Array<ChannelStyle>> {
    return new Promise((resolve, reject) => {
        Api.get(`/channelStyles/type/${type}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function createChannelStyle(model: ChannelStyle): Promise<string> {
    return new Promise((resolve, reject) => {
        Api.post("/channelStyles", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function updateChannelStyle(model: ChannelStyle): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.put("/channelStyles", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function deleteChannelStyle(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.delete(`/channelStyles/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function copyChannelStyle(model: CopyStyle): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.post("/channelStyles/copy", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function CheckChannelStyleUsage(id: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        Api.get(`/channelStyles/checkUsage/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
